module.exports = __webpack_public_path__ + "static/img/2introduce.5dbeca6d.jpg";